import { lightTheme } from '@gojitsu/web-ui-core';

export default {
  root: {
    display: 'flex',
    justifyContent: 'start',
    alignItems: 'center',

    '& >div >div': {
      boxShadow: '4px 3px 9px 0 rgba(204, 204, 204, 0.6)',
      border: 'solid 1px #e4e4e4',
    },

    '& button': {
      padding: 0,
      margin: 0,
      minWidth: '175px',
      background: 0,
      border: 'none',
      boxShadow: 'none',
      borderBottom: `1px solid ${lightTheme.palette.secondary.main}`,
      fontFamily: 'AvenirNext',
      fontSize: '18px',
      fontWeight: 900,
      color: lightTheme.palette.secondary.main,
      borderRadius: 0,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
      outline: 'none',
      textAlign: 'left',
    },
  },
  label: {
    display: 'inline-block',
    fontFamily: 'AvenirNext',
    fontSize: 18,
    fontWeight: 600,
    margin: '0px 10px',
    color: 'rgb(59, 59, 59)',
  },
  dropdownButton: {
    padding: 0,
    margin: 0,
    minWidth: '175px',
    background: 0,
    border: 'none',
    boxShadow: 'none',
    borderBottom: `1px solid ${lightTheme.palette.secondary.main}`,
    fontFamily: 'AvenirNext',
    fontSize: '18px',
    fontWeight: 900,
    color: lightTheme.palette.secondary.main,
    borderRadius: 0,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    outline: 'none',
    textAlign: 'left',
  },
  buttonLabel: {
    fontFamily: 'AvenirNext',
    fontSize: '18px',
    fontWeight: 900,
    color: lightTheme.palette.secondary.main,
    whiteSpace: 'nowrap',
  },
  clearIcon: {
    width: 18,
    cursor: 'pointer',
    color: 'gray',
    fontSize: 26,
  },
  // Menu option states, derived from the web-ui-core secondary color.
  optionHover: `${lightTheme.palette.secondary.main}14`, // secondary @ ~8% opacity
  optionSelected: lightTheme.colorTokens.secondaryContainer,
  optionActive: lightTheme.colorTokens.secondaryFixedDim,
  optionCheckbox: {
    marginRight: 8,
    accentColor: lightTheme.palette.secondary.main,
  },
  searchInput: {
    width: '100%',
    boxSizing: 'border-box',
    padding: '8px 10px',
    border: 'none',
    borderBottom: '1px solid #e0e0eb',
    outline: 'none',
    fontFamily: 'AvenirNext',
    fontSize: 14,
    color: 'rgb(59, 59, 59)',
  },
  container: {
    minWidth: 300,
    borderRadius: 5,
    boxShadow: '0 4px 10px 0 rgba(0, 0, 0, 0.2)',
    backgroundColor: '#ffffff',
    border: '1px solid #e0e0eb',
  },
};
